export default function ClientStats() {
  const stats = [
    { label: "Clientes Activos", value: "248", change: "+12%", icon: "ri-user-line", color: "text-[#2F80ED]" },
    { label: "Nuevos este mes", value: "18", change: "+5", icon: "ri-user-add-line", color: "text-[#10B981]" },
    { label: "Operaciones Totales", value: "1,847", change: "+23%", icon: "ri-ship-line", color: "text-[#114B7A]" },
    { label: "Valor Promedio", value: "$45.2K", change: "+8%", icon: "ri-money-dollar-circle-line", color: "text-[#EAB308]" },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)] hover:shadow-[0_8px_24px_rgba(10,42,67,0.12)] transition-shadow">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm text-gray-500 mb-1">{stat.label}</p>
              <p className="text-2xl font-bold text-[#0A2A43]">{stat.value}</p>
              <p className="text-xs text-[#10B981] mt-1 flex items-center gap-1">
                <i className="ri-arrow-up-line"></i>
                {stat.change}
              </p>
            </div>
            <div className={`w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]`}>
              <i className={`${stat.icon} text-2xl ${stat.color}`}></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
